import { CommentShow, CommentsList } from 'pages/admin/comments';
import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'comments',
  label: 'Comentários em aulas',
  list: CommentsList,
  show: CommentShow,
  actions: ['list', 'show'],
  parentName: 'communication'
};

export default generateResources(resource);
